import { Injectable } from '@angular/core';
import { Guid } from '@fitscovery/common/types';
import { BehaviorSubject, Observable } from 'rxjs';
import { PartnerButton } from '../models';

// TODO: This is no longer needed. Kindly remove this. Let's rely on ngxs instead.
/**
 * @class PartnerButtonStore
 */
@Injectable({ providedIn: 'root' })
export class PartnerButtonStore {

	private readonly _partnerButtons: BehaviorSubject<PartnerButton[]> = new BehaviorSubject<PartnerButton[]>([]);
	public readonly partnerButtons$: Observable<PartnerButton[]> = this._partnerButtons.asObservable();

	/**
	 * Getter will return the last value emitted in _partnerButtons subject
	 */
	private get partnerButtons(): PartnerButton[] {
		return this._partnerButtons.getValue();
	}

	/**
	 * Assigning a value to this.partnerButtons will push it onto the observable
	 * and down to all of its subsribers (ex: this.partnerButtons = [])
	 */
	private set partnerButtons(val: PartnerButton[]) {
		this._partnerButtons.next(val);
	}

	/**
	 *
	 * @param button The partner button object to add onto the collection.
	 */
	async addPartnerButton(button: any, isServerOperation: boolean = false): Promise<void> {
		try {
			if (!button?.id) {
        button = { ...button, id: null };
				button.id = Guid.newGuid();
			}

			const existingButton = this.partnerButtons.find(pb => pb.id === button.id);

			if (existingButton) {
				return;
			}

			this.partnerButtons = [...this.partnerButtons, button];

			if (isServerOperation) {
				console.warn('Method is not yet implemented.');
			}
		} catch (e) {
			console.error(e);
			this.removePartnerButton(button?.id!);
		}
	}

	/**
	 *
	 * @param id The partner button's identifier.
	 */
	getPartnerButtonById(id: string | Guid): any {
		return this.partnerButtons.find(pb => pb.id === id);
	}

	/**
	 * Deletes the partner button with the specified id.
	 *
	 * @param id The partner button's identifier.
	 * @param isServerOperation Specifies whether the operation will also remove the object in the server / database.
	 */
	removePartnerButton(id: string | Guid, isServerOperation: boolean = false): void {
		this.partnerButtons = this.partnerButtons.filter(pb => pb.id !== id);

		if (isServerOperation) {
			console.warn('Method not implemented yet.');
		}
	}

	updatePartnerButton(button: PartnerButton, isServerOperation = false): void {
		const existingButton = this.getPartnerButtonById(button.id!);

		if (existingButton) {
			this.removePartnerButton(button?.id!);
			this.addPartnerButton(button);

			if (isServerOperation) {
				console.warn('Method not implemented yet.');
			}
		}
	}
}
